module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/197.477d3cd4.png";